import { Loader } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const FullPageLoader = () => (React.createElement("div", { style: { height: 'calc(100vh - 1rem)' } },
    React.createElement(Loader, { className: "co-loader", variant: "primary" })));
export default FullPageLoader;
